import { ChainId } from '@pulsex/chains'

export const SUPPORTED_CHAIN_IDS = [
  ChainId.PULSECHAIN,
  ChainId.PULSECHAIN_TESTNET,
] as const

export type SupportedChainId = (typeof SUPPORTED_CHAIN_IDS)[number]
